var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"Banner"},[_c('span'),_vm._v(" "),_c('div',{staticClass:"item desktop",staticStyle:{"background-position":"center"},style:({ backgroundImage: 'url(' + _vm.image + ')' })}),_vm._v(" "),_c('div',{staticClass:"item mobile",style:({ backgroundImage: 'url(' + _vm.respimage + ')' })}),_vm._v(" "),_c('article',{staticClass:"box"},[_c('p',{staticClass:"title-banner"},[_vm._v(_vm._s(_vm.titulo))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1241f164","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Banner.vue
// module id = 98
// module chunks = 0